__turbopack_context__.v({
  "category": "CategorySelectionModal-module__0-WU8W__category",
  "categoryIcon": "CategorySelectionModal-module__0-WU8W__categoryIcon",
});
